import React from "react";
import Sidebar from "./sidebar";
import TopBar from "./topbar";

function Layout({ children }: any) {
  return (
    <div className="container">
      <Sidebar />
      <TopBar />
      <main>{children}</main>
    </div>
  );
}

export default Layout;
